import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SiteOff = () => {
  return (
    <div>
      <div className='padding site-off'>
        <Container>
          <Row>
            <Col lg='12'>
              <div className='site-of-text text-center text-white'>
                <div className='site-of mx-auto mb-4'>
                  <img
                    src={require('../assets/images/storelogo.png')}
                    className='img-fluid'
                    alt='Alagar Crackers'
                  />
                </div>
                <h1 className='bold lg-font mb-3' style={{ color: '#fbbf24' }}>
                  Diwali Sale Has Concluded
                </h1>
                <h3 className='regular mb-4 text-white-50'>
                  Wishing You & Your Family a Bright & Prosperous Festival of Lights! 🪔
                </h3>
                <p className='regular text-white' style={{ fontSize: '18px' }}>
                  Thank you for celebrating with Alagar Crackers. For wholesale and special function queries:
                </p>
                <div className='mt-4'>
                  <a href="tel:+919342113123" className='btn btn-warning px-4 py-2 rounded-pill fw-bold'>
                    📞 Call +91 93421 13123
                  </a>
                  <Link to="/" className='btn btn-outline-light ms-3 px-4 py-2 rounded-pill'>
                    Back to Home
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default SiteOff;